import { Popover } from '@fiverr-private/fit';

export const COLLECT_SESSION_STORAGE_KEY = 'collecting';

export const MAX_COLLECTION_NAME = 60;
export const MIN_COLLECTION_NAME = 2;

export const MAX_COLLECTION_ITEMS = 150;

export const MODAL_BASE_CLASS_NAME = 'new-collection-modal';

export const RESOURCE_TYPES = {
    GIG: 'GIG',
    SELLER: 'SELLER',
    INSPIRE_DELIVERY: 'INSPIRE_DELIVERY'
};

export const OWNER_TYPES = {
    USER: 'USER',
    BUSINESS: 'BUSINESS'
};

export const MENU_POSITIONS = Popover.POSITIONS;
